import { FC } from "react";

interface LogoSVGProps {
    className?: string;
}

const LogoSVG: FC<LogoSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="30"
            height="58"
            viewBox="0 0 30 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="1.16504" y="0.25" width="27.67" height="27.3261" stroke="black" strokeWidth="0.5" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 26.8261C22.2267 26.8261 28.085 21.0447 28.085 13.913C28.085 6.78137 22.2267 1 15 1C7.77339 1 1.91504 6.78137 1.91504 13.913C1.91504 21.0447 7.77339 26.8261 15 26.8261ZM13.3892 13.0704C13.4684 13.0463 13.5338 12.9899 13.5692 12.915L15.2178 9.42879C15.3385 9.17358 15.7147 9.21928 15.7707 9.49596L16.4305 12.7514C16.4622 12.9077 16.6129 13.0101 16.7699 12.9819L19.0747 12.5684C19.3301 12.5226 19.515 12.8065 19.3697 13.0215L17.4825 15.8151C17.4196 15.9082 17.4154 16.0292 17.4717 16.1264L19.1746 19.0673C19.3274 19.3312 19.0261 19.6242 18.7665 19.4641L15.1967 17.2623C15.0816 17.1913 14.9328 17.2082 14.8365 17.3032L12.5263 19.583C12.3409 19.766 12.0267 19.6347 12.0267 19.3741V16.1153C12.0267 16.0223 11.9826 15.9347 11.9078 15.8794L10.1166 14.5537C9.92276 14.4102 9.97516 14.1071 10.206 14.037L13.3892 13.0704Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.087 30.1196C29.087 29.9575 28.9556 29.8261 28.7935 29.8261H1.20656C1.04448 29.8261 0.913086 29.9575 0.913086 30.1196V57.7065C0.913086 57.8686 1.04448 58 1.20656 58H28.7935C28.9556 58 29.087 57.8686 29.087 57.7065V30.1196ZM2.13804 43.913C2.13804 36.8095 7.89655 31.051 15 31.051C22.1035 31.051 27.862 36.8095 27.862 43.913C27.862 51.0165 22.1035 56.775 15 56.775C7.89655 56.775 2.13804 51.0165 2.13804 43.913Z"
                fill="black"
            />
            <path
                d="M13.2942 42.6211C13.2591 42.6962 13.1939 42.753 13.1146 42.7774L9.97474 43.7435C9.74549 43.8141 9.69308 44.1149 9.88496 44.2588L11.6543 45.5859C11.7282 45.6413 11.7717 45.7283 11.7717 45.8206V49.0741C11.7717 49.3355 12.0878 49.4665 12.2727 49.2816L14.5414 47.0129C14.6381 46.9163 14.7886 46.8991 14.9045 46.9716L18.4132 49.1645C18.6719 49.3262 18.9749 49.0349 18.8235 48.77L17.1443 45.8314C17.0892 45.7349 17.0933 45.6155 17.1549 45.523L19.0187 42.7274C19.1624 42.5119 18.9768 42.2295 18.722 42.2758L16.4576 42.6875C16.3001 42.7162 16.1487 42.6133 16.1173 42.4563L15.4689 39.2141C15.4133 38.9362 15.035 38.8907 14.9152 39.1476L13.2942 42.6211Z"
                fill="black"
            />
        </svg>
    );
};

export default LogoSVG;
